/**
 * CompTabs Component
 * Tab navigation for filtering between different types of film comps
 */

import React from 'react';
import { Box, Button, Chip } from '@mui/material';
import {
  CheckCircle
} from '@mui/icons-material';

// NOTE: Modeled comps have been temporarily removed.
// They may be re-added in the future when the model improves.

const CompTabs = ({ 
  activeTab, 
  onTabChange, 
  greenlightCount = 0 
}) => {
  const tabs = [
    {
      id: 'greenlight',
      label: 'Greenlight',
      icon: <CheckCircle />,
      count: greenlightCount,
      color: '#10B981', // green
      description: 'Expert-curated comparisons'
    }
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        {tabs.map(tab => (
          <Button
            key={tab.id}
            variant={activeTab === tab.id ? 'contained' : 'outlined'}
            size="small"
            startIcon={tab.icon}
            onClick={() => onTabChange(tab.id)}
            sx={{
              minWidth: 120,
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
              transition: 'all 0.2s ease-in-out',
              position: 'relative',
              '&.MuiButton-contained': {
                backgroundColor: tab.color,
                color: 'white',
                boxShadow: `0 4px 12px ${tab.color}40`,
                '&:hover': {
                  backgroundColor: tab.color + 'dd',
                  transform: 'translateY(-1px)',
                  boxShadow: `0 6px 16px ${tab.color}50`
                }
              },
              '&.MuiButton-outlined': {
                borderColor: tab.color + '40',
                color: tab.color,
                backgroundColor: 'rgba(255,255,255,0.7)',
                '&:hover': {
                  borderColor: tab.color,
                  backgroundColor: tab.color + '10',
                  transform: 'translateY(-1px)',
                  boxShadow: `0 4px 12px ${tab.color}20`
                }
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>{tab.label}</span>
              {tab.count > 0 && (
                <Chip
                  label={tab.count}
                  size="small"
                  sx={{
                    height: 18,
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    backgroundColor: activeTab === tab.id ? 'rgba(255,255,255,0.2)' : tab.color + '20',
                    color: activeTab === tab.id ? 'white' : tab.color,
                    border: activeTab === tab.id ? 'none' : `1px solid ${tab.color}40`
                  }}
                />
              )}
            </Box>
          </Button>
        ))}
      </Box>
      
      {/* Tab descriptions */}
      <Box sx={{ mt: 1, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {tabs
          .filter(tab => tab.description)
          .map(tab => (
            <Box 
              key={`${tab.id}-desc`}
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                opacity: activeTab === tab.id ? 1 : 0.6,
                transition: 'opacity 0.2s ease-in-out'
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: tab.color
                }}
              />
              <Box sx={{ fontSize: '0.7rem', color: 'text.secondary' }}>
                {tab.description}
              </Box>
            </Box>
          ))
        }
      </Box>
    </Box>
  );
};

export default CompTabs;
